import * as util from '@/core/util';

/**
 * Diretiva para icones.
 * 
 * Exemplo:
 * 
 * <icon fa="tachometer" rotate="10" class="text-muted" />
 */
export default function icon (){
    return {
        restrict: 'E',
        replace: true,
        scope: {
            css: '@'
        },
        link: (scope, element, attrs) => {
            var elem = $(element[0]);
            var i = attrs;

            // Font Awesome
            if(i.fa){
                elem.addClass(`fa fa-${i.fa}`);
            }

            // Spin
            if(i.spin || i.spin == ''){
                if(i.fa) elem.addClass('fa-spin');
                if(i.fp) elem.addClass('fp-spin');
            }

            // Size
            if(i.size){
                if(i.fa) elem.addClass(`fa-${i.size}x`);
                if(i.fp) elem.addClass(`fp-${i.size}x`);
            }

            // Font Projecao
            if(i.fp){
                elem.addClass(`fp fp-${i.fp}`);
            }

            // Glyphicons
            if(i.bo){
                elem.addClass(`glyphicon glyphicon-${i.bo} ${i.class}`);
            }

            // Rotate icon
            if(i.rotate){
                elem.css({'transform': `rotate(${i.rotate}deg)`});
            }

            // Style
            if (i.css) {
                
                if(!!i.css){
                    scope.$watch('css', function(css){
                        elem.css(util.parseQuery(css));
                    })
                }

                elem.css(util.parseQuery(i.css));
            }

        },
        template: `<i aria-hidden="true"></i>`
    }
}


// WEBPACK FOOTER //
// ./src/directives/icone.js